import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { requestedDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { shippingMethodStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { titleStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle";
import { vmiLocationStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsVmiLocation";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

summaryTableStyles.orderLines = {
    gridContainer: {
        css: css`
            >${GridOffset}{
                width: 100%;
                margin: 0;
            }
            .card_container__wrapper {
                border: none;
                width: 100%;
                margin: 0 0 15px 0;
                > ${GridItemStyle} {
                    padding: 0;
                    > ${GridItemStyle} {
                        padding: 0;
                        > ${GridWrapper} {
                            padding: 0;
                            > ${GridOffset} {
                                width: 100%;
                                border: 1px solid ${getColor("common.border")};
                                margin: 0;
                            }
                        }
                    }
                }
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: none;
            }
        `,
    },
};

requestedDateStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};
billingAddressStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        padding-top: 10px;
    `,
};

billingAddressStyles.addressDisplay = {
    wrapper: {
        css: css`
            font-style: normal;
            p {
                font-size: 16px;
                line-height: 22px;
                color: ${getColor("secondary")};
                @media print {
                    font-size: 12px;
                }
            }
        `,
    },
};

billingAddressStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
    `,
};

shippingAddressStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
    `,
};

shippingAddressStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        padding-top: 10px;
    `,
};

shippingAddressStyles.addressDisplay = {
    wrapper: {
        css: css`
            font-style: normal;
            p {
                font-size: 16px;
                line-height: 22px;
                color: ${getColor("secondary")};
                @media print {
                    font-size: 12px;
                }
            }
        `,
    },
};

statusStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};

statusStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
        > span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
        }
    `,
};

shippingMethodStyles.wrapper = {
    css: css`
        > span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
        }
    `,
};

shippingMethodStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        padding-top: 10px;
    `,
};
vmiLocationStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};

orderDateStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
        > span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
        }
    `,
};

orderDateStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
};

titleStyles.titleText = {
    variant: "h1",
};